"use strict";
/* eslint-disable camelcase */
Object.defineProperty(exports, "__esModule", { value: true });
var mockTeamsData = {
    teams: [
        { name: 'team1', uuid: '123' },
        { name: 'team2', uuid: '234' },
        { name: 'team3', uuid: '345' },
        { name: 'team4', uuid: '456' },
    ],
    success: true,
};
exports.default = mockTeamsData;
